import { Pipe, PipeTransform } from '@angular/core';
import { Funcionalidade } from '../../modelos/funcionalidade';

@Pipe({
  name: 'filtroFuncionalidade'
})
export class FiltroFuncionalidadePipe implements PipeTransform {

  transform(funcionalidades: Funcionalidade[], filtro?: string): any {
    if (funcionalidades === undefined || filtro === undefined || filtro.trim() === '') {
      return funcionalidades;
    }
    filtro = filtro.toLocaleLowerCase();
    return funcionalidades.filter(funcionalidade => funcionalidade.nomeFuncionalidade.toLocaleLowerCase().indexOf(filtro) >= 0);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-funcionalidade.pipe.ts